import styled from "styled-components";

export const Wrapper = styled.div`
  .modal-input {
    border: 1px solid #dddddd;
    font-size: 15px;
    ::placeholder {
      color: #566787;
      font-size: 15px;
    }
  }
  .ant-modal-body {
    padding-top: 11px !important;
  }
  .modal-label {
    color: #566787;
    padding-bottom: 4px;
    padding-left: 2px;
  }
  .add-status-modal-row{
    margin-top: -10px;
  }
`;
